import {apiWithToken} from './../../../systems/api';
import {API_URL} from './../../../systems/globalContant';

export default {
    createPackage: (params) => apiWithToken.post(`${API_URL.DEFAULT}/product-returns/${params.id}/packages`, {package_code: params.package_code}, {loading: false}),
    removePackage: (params) => apiWithToken.delete(`${API_URL.DEFAULT}/product-returns/${params.id}/packages`, {params: {package_code: params.package_code}}, {loading: false}),
};
